/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

export default {
  getDataV2(plantId, device, params) {
    return Api().get(`/api/v2/communicationDiagram/${plantId}/${device}`)
  },
  getEpicStatus(plantId) {
    return Api().get(`/api/v2/communicationDiagram/${plantId}`)
  },
  getSymbol(plantId) {
    return Api().get(`/api/v1.0/symbol/communicationDiagram/${plantId}`).then(res => res.data.message)
  },
  getSVGimage(param) {
    return Api().get(`/api/v1.0/svg/${param}`).then(res => res.data)
  }
}
